import React, { useState } from 'react'
import matn1 from '../Components/fayl/maruza_matni/1.pdf'
import matn2 from '../Components/fayl/maruza_matni/2.pdf'
import matn3 from '../Components/fayl/maruza_matni/3.pdf'
import matn4 from '../Components/fayl/maruza_matni/4.pdf'
import matn5 from '../Components/fayl/maruza_matni/5.pdf'
import matn6 from '../Components/fayl/maruza_matni/6.pdf'
import matn7 from '../Components/fayl/maruza_matni/7.pdf'
import matn8 from '../Components/fayl/maruza_matni/8.pdf'
import matn9 from '../Components/fayl/maruza_matni/9.pdf'
import matn10 from '../Components/fayl/maruza_matni/10.pdf'
import matn11 from '../Components/fayl/maruza_matni/11.pdf'
import matn12 from '../Components/fayl/maruza_matni/12.pdf'
import matn13 from '../Components/fayl/maruza_matni/13.pdf'
import matn14 from '../Components/fayl/maruza_matni/14.pdf'
import matn15 from '../Components/fayl/maruza_matni/15.pdf'
import { Button, Modal } from 'antd'



export const MaruzaMatni = () => {
    const [isModalOpen, setIsModalOpen] =useState(false);
    const showModal =() => {
        setIsModalOpen(true);

    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
  return (
    <div className='card'><Button className='button' onClick={showModal}> Ma'ruzalar matni</Button> 
    <Modal className='custom-modal' open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null}>
       <br /><hr />
        <div className="button-container">
            <Button className='button'><a href={matn1}>1-ma'ruza matni</a></Button>
            <Button className='button'><a href={matn2}>2-ma'ruza matni</a></Button>
            <Button className='button'><a href={matn3}>3-ma'ruza matni</a></Button>
            <Button className='button'><a href={matn4}>4-ma'ruza matni</a></Button>
            <Button className='button'><a href={matn5}>5-ma'ruza matni</a></Button>
            <Button className='button'><a href={matn6}>6-ma'ruza matni</a></Button>
            <Button className='button'><a href={matn7}>7-ma'ruza matni</a></Button>
            <Button className='button'><a href={matn8}>8-ma'ruza matni</a></Button>
            <Button className='button'><a href={matn9}>9-ma'ruza matni</a></Button>
            <Button className='button'><a href={matn10}>10-ma'ruza matni</a></Button>
            <Button className='button'><a href={matn11}>11-ma'ruza matni</a></Button>
            <Button className='button'><a href={matn12}>12-ma'ruza matni</a></Button>
            <Button className='button'><a href={matn13}>13-ma'ruza matni</a></Button>
            <Button className='button'><a href={matn14}>14-ma'ruza matni</a></Button>
            <Button className='button'><a href={matn15}>15-ma'ruza matni</a></Button>

        </div>

    </Modal>
    </div>
  )
}
